import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SiteModel, SiteStepperModel } from 'src/app/models/index';
import {
  LoadService,
  SiteService,
  SiteStepperService
} from 'src/app/services/index';
import { SiteUtilityService } from 'src/app/services/site-utility.service';
import { SiteStepperEnum } from 'src/app/shared';
import { AlertService, Constants } from 'src/app/shared/index';
import * as ObjectUtils from 'util';
export interface Process {
  siteId: string;
  processId: string;
  loadId: string;
  processName: string;
  inputConstraint: string;
  outputConstraint: string;
  workflowType: string;
}

/**
 * Form modal for Gas accordion
 *
 * @export
 * @interface ProcessGas
 */
export interface ProcessGas {
  siteId: string;
  processId: string;
  loadId: string;
  processName: string;
  inputConstraint: string;
  outputConstraint: string;
  workflowType: string;
}

@Component({
  selector: 'app-process-and-load-details',
  templateUrl: './process-and-load-details.component.html',
  styleUrls: ['./process-and-load-details.component.scss']
})
export class ProcessAndLoadDetailsComponent implements OnInit, OnDestroy {
  siteId: string;
  siteModel: SiteModel;
  formdata: FormGroup;
  processes: any;

  process: Process;
  processWorkflow = [
    { type: 'MainProcess' },
    { type: 'PreProcess' },
    { type: 'PostProcess' },
    { type: 'BufferProcess' }
  ];

  loadDataOfSites = [];
  processname = '';
  inputconstraints = '';
  outputconstraints = '';
  workflowType = '';
  loadname = '';
  createNewProcess: string;
  isDuplicateProcessName = false;

  // For Gas accordion
  formdataGas: FormGroup;
  processesGas: any;
  processGas: ProcessGas;
  processGasWorkflow = [
    { type: 'MainProcess' },
    { type: 'PreProcess' },
    { type: 'PostProcess' },
    { type: 'BufferProcess' }
  ];
  loadGasDataOfSites = [];
  createNewGasProcess: string;
  isDuplicateGasProcessName = false;
  gasUtility: Boolean = true;

  constructor(
    private fb: FormBuilder,
    private siteStepperService: SiteStepperService,
    private loadService: LoadService,
    private siteService: SiteService,
    private activeRoute: ActivatedRoute,
    private alertService: AlertService,
    private siteUtilityService: SiteUtilityService
  ) {
    this.initNewProcess();
    this.initNewProcessGas();
  }

  private initNewProcess() {
    this.process = {
      siteId: '',
      loadId: '',
      processId: '',
      processName: '',
      inputConstraint: '',
      outputConstraint: '',
      workflowType: ''
    };
    this.isDuplicateProcessName = false;
  }

  /**
   * Defining modal for gas process
   *
   * @private
   * @memberof ProcessAndLoadDetailsComponent
   */
  private initNewProcessGas() {
    this.processGas = {
      siteId: '',
      loadId: '',
      processId: '',
      processName: '',
      inputConstraint: '',
      outputConstraint: '',
      workflowType: ''
    };
    this.isDuplicateGasProcessName = false;
  }

  ngOnInit() {
    const t = this;
    this.createNewProcess = '';
    this.createNewGasProcess = '';
    this.workflowType = '';
    this.siteModel = new SiteModel();
    t.formdata = t.fb.group({
      createNewProcessCtr: [],
      processCtr: [],
      processnameCtr: ['', [Validators.required, this.startWhitespace]],
      inputconstraintsCtr: [
        '',
        [Validators.minLength(1), Validators.maxLength(6), this.startWhitespace]
      ],
      outputconstraintsCtr: [
        '',
        [Validators.minLength(1), Validators.maxLength(6), this.startWhitespace]
      ],
      workflowTypeCtr: [],
      loadRIdCtr: ['']
    });
    // Creating form group for Gas form accordion
    t.formdataGas = t.fb.group({
      createNewGasProcessCtr: [],
      processGasCtr: [],
      processGasnameCtr: ['', [Validators.required, this.startWhitespace]],
      inputconstraintsGasCtr: [
        '',
        [Validators.minLength(1), Validators.maxLength(6), this.startWhitespace]
      ],
      outputconstraintsGasCtr: [
        '',
        [Validators.minLength(1), Validators.maxLength(6), this.startWhitespace]
      ],
      workflowTypeGasCtr: [],
      loadRIdGasCtr: ['']
    });
    this.siteStepperService.getStepperSubject().subscribe((data) => {
      if (
        data.selectedIndex === SiteStepperEnum.ProcessAndLoadDetails &&
        !ObjectUtils.isNullOrUndefined(data.siteModel)
      ) {
        this.refreshData();
        this.siteId = data.siteModel.siteId;
        this.siteModel = data.siteModel;
        this.getProcessAndLoadsOfSite();
        if (this.siteModel.configuredKpiUtilities.includes('Gas')) {
          this.gasUtility = false;
          this.getGasProcessAndLoadsOfSite();
        }
      }
    });
  }
  public startWhitespace(control: FormControl) {
    if (
      (control.value as string) &&
      (control.value as string).indexOf(' ') == 0
    ) {
      return { whitespace: true };
    }
    return null;
  }
  ngOnDestroy() {
    const t = this;
  }

  refreshData() {
    this.loadDataOfSites = [];
    this.createNewProcess = '';
    this.workflowType = '';
    this.initNewProcess();
  }

  getProcessAndLoadsOfSite() {
    const t = this;
    this.initNewProcess();
    t.siteService
      .getProcessAndLoadsBySiteId(t.siteId, false)
      .subscribe((data) => {
        // if (data.length > 0) {
        t.processes = data;
        t.getAllLoads();
        // }
      });
  }

  getAllLoads() {
    this.loadService.getAllLoadsOfSite(this.siteId).subscribe((data) => {
      if (data.length > 0) {
        this.loadDataOfSites = data;
      }
    });
  }

  /**
   * Function to get all process and loads for particular siteId gas utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  getGasProcessAndLoadsOfSite() {
    const t = this;
    this.initNewProcessGas();
    t.siteUtilityService
      .getUtilityProcessAndLoadsBySiteId(t.siteId, 'Gas', false)
      .subscribe((data) => {
        t.processesGas = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        t.processesGas = data;
        t.getAllGasLoads();
      });
  }

  /**
   * Function to get all loads for particular siteId gas utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  getAllGasLoads() {
    this.loadService
      .getLoadVerticesOfSiteBasedOnUtility(this.siteId, 'Gas')
      .subscribe((data) => {
        if (data) {
          this.loadGasDataOfSites = data.sort((a, b) =>
            a.name > b.name ? 1 : -1
          );
        }
      });
  }

  insertProcessMaster() {
    const t = this;
    const params = {
      siteId: t.siteId,
      processId: t.process.processId,
      loadId: t.process.loadId,
      processName: t.process.processName,
      inputConstraint: t.process.inputConstraint,
      outputConstraint: t.process.outputConstraint,
      workflowType: t.process.workflowType,
      kpiName: 'Energy'
    };
    t.siteService.saveProcess(params).subscribe((data) => {
      if (data.result === Constants.SUCCESS) {
        this.alertService.message = 'Save success';
        this.alertService.showSuccess();
        t.getProcessAndLoadsOfSite();
      } else {
        this.alertService.message = data.message;
        this.alertService.showError();
      }
    });
  }

  /**
   * Function call to add new process for gas utility when button with buttonId 'addGasProcessbtn' is clicked
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  insertGasProcessMaster() {
    const t = this;
    const params = {
      siteId: t.siteId,
      processId: t.processGas.processId,
      loadId: t.processGas.loadId,
      processName: t.processGas.processName,
      inputConstraint: t.processGas.inputConstraint,
      outputConstraint: t.processGas.outputConstraint,
      workflowType: t.processGas.workflowType,
      kpiName: 'Gas'
    };
    t.siteUtilityService.saveUtilityProcessForSite(params).subscribe((data) => {
      if (data.result === Constants.SUCCESS) {
        this.alertService.message = 'Save success';
        this.alertService.showSuccess();
        t.getGasProcessAndLoadsOfSite();
      } else {
        this.alertService.message = data.message;
        this.alertService.showError();
      }
    });
  }

  public previousStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.ShiftDetails, this.siteModel)
    );
  };
  nextStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.GroupConfiguration, this.siteModel)
    );
  };

  onProcessNameFocusOut() {
    const processName = this.process.processName.toLowerCase();
    this.isDuplicateProcessName = false;
    if (processName && processName !== '') {
      if (this.processes && this.processes.length > 1) {
        for (let i = 0; i < this.processes.length; i++) {
          if (this.processes[i].name.toLowerCase() === processName) {
            this.isDuplicateProcessName = true;
            break;
          }
        }
      }
    }

    if (this.isDuplicateProcessName) {
      this.formdata.get('processnameCtr').setErrors({ duplicated: true });
    } else {
      const error = this.formdata.get('processnameCtr').getError('duplicated');
      if (error) {
        this.formdata.get('processnameCtr').setErrors(null);
      }
    }
  }

  /**
   * Function call to check for duplicate process name for gas utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  onGasProcessNameFocusOut() {
    const processGasName = this.processGas.processName.toLowerCase();
    this.isDuplicateGasProcessName = false;
    if (processGasName && processGasName !== '') {
      if (this.processesGas && this.processesGas.length > 1) {
        for (let i = 0; i < this.processesGas.length; i++) {
          if (this.processesGas[i].name.toLowerCase() === processGasName) {
            this.isDuplicateGasProcessName = true;
            break;
          }
        }
      }
    }

    if (this.isDuplicateGasProcessName) {
      this.formdataGas.get('processGasnameCtr').setErrors({ duplicated: true });
    } else {
      const error = this.formdataGas
        .get('processGasnameCtr')
        .getError('duplicated');
      if (error) {
        this.formdataGas.get('processGasnameCtr').setErrors(null);
      }
    }
  }

  onCreateNewProcessSelectionChanged() {
    this.process.processName = '';
    this.onProcessNameFocusOut();
  }

  /**
   * Function call on creation of new process for gas utility
   *
   * @memberof ProcessAndLoadDetailsComponent
   */
  onCreateNewGasProcessSelectionChanged() {
    this.processGas.processName = '';
    this.onGasProcessNameFocusOut();
  }

  isFormValid() {
    if (this.createNewProcess === undefined || this.createNewProcess === '') {
      return false;
    }

    if (this.createNewProcess === 'true') {
      if (
        ObjectUtils.isNullOrUndefined(this.process.processName) ||
        this.process.processName === ''
      ) {
        return false;
      }
      if (
        ObjectUtils.isNullOrUndefined(this.process.workflowType) ||
        this.process.workflowType === ''
      ) {
        return false;
      }
      if (
        ObjectUtils.isNullOrUndefined(this.process.loadId) ||
        this.process.loadId === ''
      ) {
        return false;
      }
      if (this.isDuplicateProcessName) {
        return false;
      }
    } else {
      if (
        ObjectUtils.isNullOrUndefined(this.process.processId) ||
        this.process.processId === ''
      ) {
        return false;
      }
      if (
        ObjectUtils.isNullOrUndefined(this.process.loadId) ||
        this.process.loadId === ''
      ) {
        return false;
      }
    }

    return true;
  }

  /**
   * Function call to check gas utility form valid
   *
   * @return {*}
   * @memberof ProcessAndLoadDetailsComponent
   */
  isGasFormValid() {
    if (
      this.createNewGasProcess === undefined ||
      this.createNewGasProcess === ''
    ) {
      return false;
    }

    if (this.createNewGasProcess === 'true') {
      if (
        this.processGas.processName === null ||
        this.processGas.processName === undefined ||
        this.processGas.processName === ''
      ) {
        return false;
      }
      if (
        this.processGas.workflowType === null ||
        this.processGas.workflowType === undefined ||
        this.processGas.workflowType === ''
      ) {
        return false;
      }
      if (
        this.processGas.loadId === null ||
        this.processGas.loadId === undefined ||
        this.processGas.loadId === ''
      ) {
        return false;
      }
      if (this.isDuplicateGasProcessName) {
        return false;
      }
    } else {
      if (
        this.processGas.processId === null ||
        this.processGas.processId === undefined ||
        this.processGas.processId === ''
      ) {
        return false;
      }
      if (
        this.processGas.loadId === null ||
        this.processGas.loadId === undefined ||
        this.processGas.loadId === ''
      ) {
        return false;
      }
    }

    return true;
  }
}
